import React, { Suspense, useEffect } from 'react'
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { resolveDisplayConfig } from 'src/clinic/services/screenConfigMigration'

const KioskSelectFlowPage = React.lazy(() => import('src/clinic/components/KioskSelectFlowPage'))
const ClinicCounterForMentor = React.lazy(() =>
  import('src/clinic/components/ClinicCounterScreen/ClinicCounterForMentor'),
)

// Base /display redirect — server is the source of truth for what this screen
// shows. resolveDisplayConfig() handles: server config → one-time migration of
// any legacy localStorage config to the server → write-through cache fallback
// when offline. The display route accepts location/mentor IDs (the screen
// resolves them), so we navigate with IDs directly.
function DisplayLandingRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    let cancelled = false
    async function resolve() {
      const cfg = await resolveDisplayConfig()
      if (cancelled) return
      if (cfg?.clinicLocationId && cfg?.mentorId) {
        navigate(`/display/${cfg.clinicLocationId}/${cfg.mentorId}`, { replace: true })
      } else {
        navigate('/display/select-flow', { replace: true })
      }
    }
    resolve()
    return () => {
      cancelled = true
    }
  }, [navigate])

  return <LoadingSpinner />
}

export default function DisplayRoutesHandler() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="select-flow" element={<KioskSelectFlowPage />} />
        <Route path=":location/:mentor" element={<ClinicCounterForMentor />} />
        <Route path="/" element={<DisplayLandingRedirect />} />
        <Route path="*" element={<Navigate to="/display/select-flow" replace />} />
      </Routes>
    </Suspense>
  )
}
